import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/Service/notification.service';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ITransmittalDistributionModel, ITransmittalReceiverDetails } from 'src/app/ViewModel/TransmittalTemplateModel';

@Component({
  selector: 'app-transmittal-template-copy',
  templateUrl: './transmittal-template-copy.component.html',
  styleUrls: ['./transmittal-template-copy.component.css']
})
export class TransmittalTemplateCopyComponent implements OnInit {


  transmittalForm: FormGroup | undefined;
  isCheckAction: boolean = false;
  Distribution_List: any[] = [];

  constructor(private _formBuilder: FormBuilder, private _notificationService: NotificationService,
    private _transmittalService: TransmittalService, @Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<TransmittalTemplateCopyComponent>) { }

  ngOnInit() {
    this.Distribution_List = this._data.DistributionList.map((x: { category: any; copy_Type: any; quantity: any; receiver_Group: any; remarks: any; }) => {
      let obj = {
        category: x.category,
        copy_Type: x.copy_Type,
        quantity: x.quantity,
        receiver_Group: x.receiver_Group,
        remarks: x.remarks
      }
      return obj;
    })
    this.transmittalForm = this._formBuilder.group({
      TemplateNewName: new FormControl('', [Validators.required])
    })
  }

  closeDialog() {
    this.dialogRef.close(this.isCheckAction);
  }


  postData() {
    let newTemplateName: string = this.transmittalForm?.get('TemplateNewName')?.value
    if (!newTemplateName) {
      return;
    }
    let dublicateData = this._data.TemplateDetails.filter((data: { template_Name: string; }) => data.template_Name == newTemplateName.trim())[0];
    if (!!dublicateData) {
      this._notificationService.showPopup("Entered TemplateName already Exists", "Warning");
      return;
    }
    let transmittalDetailsInput = {
      "category": this._data.TransmittalData[0].category,
      "group_Id": this._data.TransmittalData[0].group_Id,
      "is_Active": true,
      "project_Id": this._data.TransmittalData[0].project_Id,
      "quantity": this._data.TransmittalData[0].quantity,
      "template_Id": undefined,
      "template_Name": newTemplateName,
      "template_Remarks": this._data.TransmittalData[0].template_Remarks,
      "template_Subject": this._data.TransmittalData[0].template_Subject,
      "userId": 162067
    }
    this._transmittalService.InsertUpdateTransmittalDetails(transmittalDetailsInput).subscribe((x: StandardOutputModel) => {
      if (x.successCode == 200) {
        let templateId: number = +x.result;
        let transmittalReceiverDetails = this.saveTransmittalReceiverDetails(templateId);
        let transmittalDistributionDetails = this.saveTransmittalDistributionDetails(templateId);
        forkJoin([transmittalReceiverDetails,
          transmittalDistributionDetails]).subscribe((res: any[]) => {
            this._notificationService.showPopup("Transmittal Template has been saved successfully", "Success");
            this.isCheckAction = true;
            this.closeDialog();
          })
      }
      else {
        this._notificationService.showPopup(x.successMessage, "Warning");
      }
    })
  }

  saveTransmittalReceiverDetails(templateId: number) {
    let transmittalReceiverInput: ITransmittalReceiverDetails = {
      'template_Id': templateId,
      'receiverFromDetails': this._data.TransmittalReceiverDetails[0].receiverFromDetails,
      'receiverToDetails': this._data.TransmittalReceiverDetails[0].receiverToDetails,
      'receiverCcDetails': this._data.TransmittalReceiverDetails[0].receiverCcDetails,
      'is_Active': true,
      'userId': this._data.userId,
    }
    return this._transmittalService.InsertUpdateTransmittalReceiverDetails(transmittalReceiverInput);
  }

  saveTransmittalDistributionDetails(templateId: number) {
    let transmittalDistributionInput: ITransmittalDistributionModel = {
      'project_Id': this._data.project_Id,
      'template_Id': templateId,
      'DistributionGroupDetails': this.Distribution_List,
      'is_Active': true,
      'userId': 162067
    }
    return this._transmittalService.InsertUpdateTransmittalDistributionDetails(transmittalDistributionInput)
  }

  getDistribution() {

  }

}



